export default __webpack_public_path__ + "static/404-93a149295a019cb314f484839ae56387.png";